import { Reveal } from "@/components/common/Reveal";
import { Sun, Home, Handshake } from "lucide-react";

const options = [
    {
        icon: Home,
        title: "Location de toiture",
        text: "Valorisez vos surfaces de toiture en accueillant une centrale solaire.",
    },
    {
        icon: Handshake,
        title: "Bail à construction",
        text: "Un bâtiment financé et construit en partenariat, adapté à votre exploitation.",
    },
    {
        icon: Sun,
        title: "Achat de centrales",
        text: "Investissez dans votre production solaire, en fonds propres ou avec un investisseur.",
    },
];

export const Solar = () => (
    <section
        data-testid="solar-section"
        className="relative bg-white py-24 lg:py-32 px-6 md:px-12"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="grid gap-10 lg:grid-cols-12 lg:gap-16 items-center">
                <div className="lg:col-span-6">
                    <Reveal>
                        <div className="overflow-hidden rounded-[2rem]">
                            <img
                                src="/images/solar1.jpg"
                                alt="Bâtiment agricole équipé de panneaux solaires"
                                className="h-full w-full object-cover aspect-[5/4] transition-transform [transition-duration:1200ms] hover:scale-105"
                            />
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-6">
                    <Reveal>
                        <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                            Bâtiments solaires
                        </span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-5 text-[clamp(1.9rem,4vw,3rem)] font-bold tracking-tight leading-[1.08] text-rz-ink">
                            Optimisez votre production solaire, partout en France.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="mt-6 text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                            Nous concevons vos bâtis solaires avec tous les investisseurs du marché,
                            sans exclusivité. Regardons ensemble les options qui correspondent à
                            votre projet et à vos besoins.
                        </p>
                    </Reveal>

                    <div className="mt-8 space-y-4">
                        {options.map((o, i) => (
                            <Reveal key={o.title} delay={0.1 * i}>
                                <div
                                    data-testid={`solar-option-${i}`}
                                    className="group flex items-start gap-4 rounded-xl border border-black/5 bg-rz-bg/60 p-5 transition-all duration-300 hover:border-rz-sage/40 hover:bg-white hover:shadow-md"
                                >
                                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rz-pale/40 text-rz-green transition-colors duration-300 group-hover:bg-rz-green group-hover:text-white">
                                        <o.icon size={20} />
                                    </span>
                                    <div>
                                        <h3 className="font-display font-bold text-rz-ink">
                                            {o.title}
                                        </h3>
                                        <p className="mt-1 text-sm text-rz-ink-soft leading-relaxed">
                                            {o.text}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);
